<template>
  <div>
    <div class="d-flex align-items-center">
      <img src="@/assets/img/clock-rotate-left-orange.svg" />
      <span class="color-black font-16 font-weight-normal ml-3">
        Historial de Versiones
      </span>
    </div>
    <time-line v-if="items.length" class="mt-2">
      <time-line-item v-for="(item, index) in items" :key="`comment-${index}`">
        <template #icon>
          <div class="bg-gray-2 timeline-icon-container">
            <img
              src="@/assets/img/clock-rotate-left.svg"
              style="height: 16px;"
            />
          </div>
        </template>
        <template #date>
          <div>
            <span class="data-title d-block">Fecha:</span>
            <span class="d-block font-weight-bold">
              {{ item.createdDate | date }}
            </span>
            <span class="hour">
              {{ item.createdDate | hour }}
            </span>
          </div>
        </template>
        <div class="row">
          <div class="col-12 col-md-3 pl-5 d-flex align-items-center">
            <span class="font-18 color-black font-weight-bold">
              {{ versionNumber(item) }}
            </span>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <span class="data-title d-block border-mobile">
                Estatus:
              </span>
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-circle font-12 mr-2"
                  :class="`color-${statusColor(item)}`"
                />
                <span class="font-16 font-weight-bold">
                  {{ item.statusName | empty }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <span class="data-title d-block border-mobile">
              Modificado Por:
            </span>
            <span class="font-16 color-black">
              {{ item.updatedByName | empty }}
            </span>
          </div>
          <div
            class="col-12 col-md-3 d-flex align-items-center justify-content-end"
          >
            <action-button
              id="btnShowChanges"
              i="fa fa-file-search"
              :responsive="false"
              text="Ver Versión"
              variant="outline-success ok-btn"
              @click="handleViewVersion(item)"
            />
          </div>
        </div>
      </time-line-item>
    </time-line>
    <custom-result-not-found
      v-else
      text="No se encontraron versiones registradas."
    />
  </div>
</template>

<script>
//libs
import CustomResultNotFound from 'custom-result-not-found';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import ActionButton from 'ActionButton';

// constants
import rpContractEditorVersionStatus, {
  rpContractEditorVersionStatusColor,
} from '@/utils/constants/rpContractEditorVersionStatus.js';

export default {
  name: 'ContractVersios',
  components: {
    CustomResultNotFound,
    TimeLine,
    TimeLineItem,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      action: undefined,
    };
  },
  computed: {
    versionNumber() {
      return (item) => `v${item.versionNumber}.0`;
    },
    statusColor() {
      return (item) =>
        ({
          [rpContractEditorVersionStatus.Draft]:
            rpContractEditorVersionStatusColor[
              rpContractEditorVersionStatus.Draft
            ],
          [rpContractEditorVersionStatus.Published]:
            rpContractEditorVersionStatusColor[
              rpContractEditorVersionStatus.Published
            ],
          [rpContractEditorVersionStatus.Inactive]:
            rpContractEditorVersionStatusColor[
              rpContractEditorVersionStatus.Inactive
            ],
        }[item.statusId] || null);
    },
  },
  methods: {
    handleViewVersion(item) {
      this.$emit('on-view-version', { ...item });
    },
  },
};
</script>

<style scoped lang="scss">
.timeline-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  height: 31px;
  width: 31px;
  margin-top: 12px;
  margin-left: 2px;
  img {
    margin-top: 1px !important;
  }
}
</style>
